import React, { useEffect , useState } from 'react';
import { fetchMyTravelNotConfirmedYet , fetchMyTravel} from '../../apiCall';

function NotConfirmedYet(props) {
  const [userInvitations, setUserInvitations] = useState([]);
  const [error, setError] = useState(false);
  const [privateTravels, setPrivateTravels] = useState([]);


  useEffect(() => {
    getMyTravel();
    getTravelNotConfirmedYet();
  }, []);

  const getTravelNotConfirmedYet = () => {
    fetchMyTravelNotConfirmedYet(props.uid, function(response) {
      if (!response.result || response.result.length === 0) {
        setError(true);
      } else {
        const filteredResult = response.result.filter((invitation) => {
          return !privateTravels.some((privateTravel) => privateTravel.connectedCustomerInvitationId === invitation.id);
        });
        const filteredIds = filteredResult.map((invitation) => invitation.id);
        const finalResult = response.result.filter((invitation) => filteredIds.includes(invitation.id));
        setUserInvitations(finalResult);
      }
    })
      .then(() => {
      })
      .catch(() => {
        alert('שגיאה.');
      });
  };
  const getMyTravel = () => {
     fetchMyTravel(props.uid, function(response){
        if (!response.result || response == null || response.result == []) {
          } else {
            setPrivateTravels(response.result)
          }
      }).then(()=>{
      }).catch(()=>{
        alert('שגיאה.')
      });
}

  return (
    <div>
        <div>
    <h4 className='titles'>נסיעות שעוד לא אושרו</h4>
    {userInvitations && (
        <div className="card-container">
            {userInvitations.map((invitation) => (
                <div className='invitationCard'
                 key={invitation.id}>
                    <div className='direction'>
                     <span className="fieldLabel"> סוג נסיעה:</span>
                     <span>{invitation?.travelType}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel">שם: </span>
                     <span>{invitation?.name}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel">כמות נסעים: </span>
                     <span>{invitation?.amount}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel"> תאריך ושעה: </span>
                     <span>{invitation?.date}, {invitation?.time}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel"> טלפון: </span>
                     <span>{invitation?.phone}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel"> מסלול: </span>
                     <span>{invitation?.orbit?.hebrewAdress}</span>
                    </div><div className='direction'>
                     <span className="fieldLabel"> רכב: </span>
                     <span>{invitation?.car?.carTypeHebrew}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel"> הערות: </span>
                     <span>{invitation?.notes}</span>
                    </div>
                </div>
            ))}
        </div>
    )}
</div> 
    </div>
  )
}

export default NotConfirmedYet;